import {
  DEMO_STEP_IDS,
  isDemoIncomplete,
  normalizeDemoStepsCompleted,
} from '../demo/demoSteps';

export const BILLING_ONLY_PATHS = ['/billing', '/faq', '/profile', '/debug', '/demo'];

// Statuses that grant access. 'canceled' means the subscription is set to
// cancel at period end but the paid period is still running.
// 'over_limit' means the user is over max_candidates after a downgrade —
// app access stays, but n8n scraping is paused until they delete down to the limit.
// A background cron flips ended subscriptions to 'expired', so status is the
// source of truth; the date check below is a defensive backstop between runs.
const ACTIVE_STATUSES = new Set(['active', 'canceled', 'over_limit']);

function isPeriodActive(profile) {
  const endValue = profile?.current_period_end || profile?.trial_ends_at;

  if (!endValue) return true;

  const periodEnd = new Date(endValue);
  if (Number.isNaN(periodEnd.getTime())) return true;

  return periodEnd.getTime() >= Date.now();
}

export const hasActiveSubscription = (profile) => (
  Boolean(profile?.subscription_plan?.trim()) &&
  ACTIVE_STATUSES.has(profile?.subscription_status) &&
  isPeriodActive(profile)
);

export const needsSubscriptionSelection = (profile) => (
  Boolean(profile) && !hasActiveSubscription(profile)
);

export const canAccessWelcomeGuide = (profile) => (
  Boolean(profile?.demo_completed_at) && needsSubscriptionSelection(profile)
);

export const isBillingOnlyPath = (pathname) => (
  BILLING_ONLY_PATHS.includes(pathname)
);

export { isDemoIncomplete, normalizeDemoStepsCompleted, DEMO_STEP_IDS };

export const getDefaultAuthenticatedPath = (profile) => {
  // A missing profile is a new account, not a finished one. Sending it to
  // the dashboard skips the welcome guide.
  if (!profile || isDemoIncomplete(profile)) return '/demo';
  if (needsSubscriptionSelection(profile)) return '/billing';
  return '/dashboard';
};
